export function getDomRefs(root = document) {
    return {
        form: root.querySelector("#clipper-form"),
        imageInput: root.querySelector("#image-input"),
        tilesWideInput: root.querySelector("#tiles-wide"),
        tilesHighInput: root.querySelector("#tiles-high"),
        gameSelect: root.querySelector("#game-select"),
        gameHelper: root.querySelector("#game-helper"),
        tileResolutionInput: root.querySelector("#tile-resolution"),
        tileResolutionQuickInput: root.querySelector("#tile-resolution-quick"),
        scalingModeFitButton: root.querySelector("#scaling-mode-fit"),
        scalingModeEnhanceButton: root.querySelector("#scaling-mode-enhance"),
        scalingModeButtons: root.querySelectorAll("[data-scaling-mode]"),
        maxFitResolutionHelper: root.querySelector("#max-fit-resolution-helper"),
        maxFitResolutionValue: root.querySelector("#max-fit-resolution-value"),
        effectiveResolutionHelper: root.querySelector("#effective-resolution-helper"),
        effectiveResolutionValue: root.querySelector("#effective-resolution-value"),
        gameMeta: root.querySelector("#game-meta"),
        gameMetaTitle: root.querySelector("#game-meta-title"),
        gameMetaResolution: root.querySelector("#game-meta-resolution"),
        gameMetaUsage: root.querySelector("#game-meta-usage"),
        statusText: root.querySelector("#status-text"),
        progressBar: root.querySelector("#progress-bar"),
        generateButton: root.querySelector("#generate-button"),
        cancelButton: root.querySelector("#cancel-button"),
        previewCanvas: root.querySelector("#preview-canvas"),
        cropOverlay: root.querySelector("#crop-overlay"),
        imageMeta: root.querySelector("#image-meta")
    };
}
